module.exports = __webpack_public_path__ + "img/peserta.1513bdbc.svg";